<template>
  <template v-if="dependenciesReport && !loading">
    <vl-title v-if="title" tag-name="h1"> {{ title }} </vl-title>
    <DependencyTable
      v-if="showProductProcessDefinitions"
      entity-type="productprocessdefinition"
      :items="productProcessDefinitions"
      :title="$t('productprocessdefinition.dependencies.productProcessDefinitions.title')"
      :no-results-text="$t('productprocessdefinition.dependencies.productProcessDefinitions.noResults')"
    />
    <DependencyTable
      v-if="showProcessTriggers"
      entity-type="processtrigger"
      label-accessor-key="description"
      :items="processTriggers"
      :title="$t('productprocessdefinition.dependencies.processTriggers.title')"
      :no-results-text="$t('productprocessdefinition.dependencies.processTriggers.noResults')"
    />
    <DependencyTable
      v-if="showProductGroups"
      entity-type="productgroup"
      :items="productGroups"
      :title="$t('productprocessdefinition.dependencies.productGroups.title')"
      :no-results-text="$t('productprocessdefinition.dependencies.productGroups.noResults')"
    />
    <ProductRunsTable v-if="showProductRuns" :productRuns="productRuns" />
  </template>
  <template v-if="loading">
    <vl-region>
      <vl-loader :message="$t('productprocessdefinition.dependencies.loading')" />
    </vl-region>
  </template>
</template>
<script lang="ts" setup>
import {
  ProcessTriggerBasicDto,
  ProductGroupBasicDto,
  ProductProcessDefinitionBasicDto,
  ProductProcessDefinitionDependenciesReportDto,
  ProductRunBasicDto
} from '@/api/backoffice/clients';
import { useProductProcessDefinitionDetailStore } from '@/modules/configuration/store/product-process-definition/product-process-definition-detail.store';
import { computed, onMounted, reactive } from 'vue';
import DependencyTable from '@/modules/configuration/views/shared/DependencyTable.vue';
import ProductRunsTable from './ProductRunsTable.vue';

const store = useProductProcessDefinitionDetailStore();

const props = defineProps({
  id: {
    type: Number,
    required: true
  },
  title: {
    type: String,
    default: ''
  },
  showProductProcessDefinitions: {
    type: Boolean,
    default: true
  },
  showProcessTriggers: {
    type: Boolean,
    default: true
  },
  showProductRuns: {
    type: Boolean,
    default: true
  },
  showProductGroups: {
    type: Boolean,
    default: true
  }
});

const data = reactive({
  isLoading: false
});

const loading = computed(() => {
  return data.isLoading;
});

const dependenciesReport = computed((): ProductProcessDefinitionDependenciesReportDto => {
  return store.dependenciesReport;
});

const productProcessDefinitions = computed((): ProductProcessDefinitionBasicDto[] => {
  return dependenciesReport.value?.productProcessDefinitions;
});

const processTriggers = computed((): ProcessTriggerBasicDto[] => {
  return dependenciesReport.value?.processTriggers;
});

const productRuns = computed((): ProductRunBasicDto[] => {
  return dependenciesReport.value?.productRuns;
});

const productGroups = computed((): ProductGroupBasicDto[] => {
  return dependenciesReport.value?.productGroups;
});

onMounted(async () => {
  data.isLoading = true;
  await store.getDependenciesReport(props.id);
  data.isLoading = false;
});
</script>
<style lang="scss" scoped></style>
